@let customer = customer$ | async;
@let seconds = cooldownUntilSeconds$ | async;

<div class="verify-email">
  <div class="verify-email-card">
    <div class="verify-email-wrap">
      <app-ds-rounded-icon icon="mail" size="large" customColor="var(--color-core-neutral-3)"></app-ds-rounded-icon>
      <h3 class="ds-title-3">{{ 'ONBOARDING.emailValidation.Heading' | translate }}</h3>
      <h4 class="ds-ui-1 ds-color-core-neutral-8">{{ 'ONBOARDING.emailValidation.Subheading' | translate }}</h4>
      <input [value]="customer?.email" type="email" class="ds-input" readonly disabled />
      <h4 class="ds-ui-1 ds-color-core-neutral-8">{{ 'ONBOARDING.emailValidation.Instruction' | translate }}</h4>
      <p class="ds-ui-2 ds-color-core-neutral-6">{{ 'ONBOARDING.emailValidation.SpamReminder' | translate }}</p>
      <p class="ds-ui-2 ds-color-core-neutral-6">{{ 'ONBOARDING.emailValidation.ExpiryReminder' | translate: { expirationHours: 24 } }}</p>

      @if (resendSubmitted$ | async) {
        <div class="verify-email-sent">
          <app-ds-icon name="check" color="var(--color-system-success-3)" size="icon-size-2"></app-ds-icon>
          <p class="ds-ui-2">{{ 'ONBOARDING.emailValidation.ResendNotice' | translate }}</p>
        </div>
      }

      <div class="verify-email-separator"></div>
      <span class="ds-caption-3 ds-color-core-neutral-6">{{ 'ONBOARDING.emailValidation.NoEmailQuestion' | translate }}</span>
      @if (seconds) {
        <span class="ds-caption-3 ds-color-core-neutral-6">{{ 'ONBOARDING.emailValidation.ResendWait' | translate: { seconds } }}</span>
      } @else {
        <a href="javascript:;" (click)="onResendEmail(customer?.id)" class="ds-ui-2 ds-color-core-neutral-10">{{
          'ONBOARDING.emailValidation.ResendButton' | translate
        }}</a>
      }
    </div>
  </div>
</div>
